import { useEffect, useState } from "react";

const getIsDarkMode = () => document.body.classList.contains("dark-mode");

export function useDarkMode() {
  const [isDarkMode, setIsDarkMode] = useState(getIsDarkMode);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(getIsDarkMode());
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return isDarkMode;
}
